module.exports = __webpack_public_path__ + "img/liveInd.e709f6db.png";